import * as Highcharts from 'highcharts';
import { DashboardConstants } from './dashboard-constants';

export const BARCHARTOPTIONS: Highcharts.Options = {
  chart: {
    type: 'column',
    backgroundColor: '#fcfcfd',
    spacing: [15, 0, 10, 0],
  },
  title: {
    text: '',
  },
  xAxis: {
    categories: ['Gateways', 'Camera'],
    labels: {
      y: 15,
      style: {
        fontFamily: DashboardConstants.EVENTTYPELINECHARTFONT,
        fontSize: '10px',
      },
    },
  },
  yAxis: {
    min: 0,
    title: {
      text: 'Count',
    },
    stackLabels: {
      enabled: true,
    },
  },
  legend: {
    align: 'left',
    verticalAlign: 'top',
    symbolRadius: 0,
    itemStyle: {
      fontFamily: DashboardConstants.EVENTTYPELINECHARTFONT,
      fontSize: '10px',
      fontWeight: '500',
      padding: '10',
    },
    reversed: true,
  },
  tooltip: {
    headerFormat: '<b>{point.x}</b><br/>',
    pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}',
  },
  plotOptions: {
    column: {
      stacking: 'normal',
      borderWidth: 0,
    },
  },
  series: [],
};

export const LINECHARTOPTIONS: Highcharts.Options = {
  chart: {
    backgroundColor: '#fcfcfd',
    spacing: [0, 0, 0, -3],
    marginRight: 5,
  } as Highcharts.ChartOptions,
  title: {
    text: '',
  },
  time: { useUTC: false },
  xAxis: {
    type: 'datetime',
    dateTimeLabelFormats: {
      day: '%b %e',
    },
    labels: {
      style: {
        fontFamily: DashboardConstants.EVENTTYPELINECHARTFONT,
        fontSize: '10px',
      },
    },
    title: {},
    gridLineColor: '#333',
  },
  yAxis: [
    {
      title: {
        text: 'No. of events',
        style: {
          fontFamily: DashboardConstants.EVENTTYPELINECHARTFONT,
          fontSize: '12px',
          fontWeight: '700',
        },
      },
      labels: {
        style: {
          fontFamily: DashboardConstants.EVENTTYPELINECHARTFONT,
          fontSize: '10px',
        },
      },
    },
  ],
  tooltip: {
    distance: 20,
    outside: false,
    shared: true,
  },
  legend: {
    align: 'left',
    verticalAlign: 'top',
    enabled: true,
    itemStyle: {
      fontFamily: DashboardConstants.EVENTTYPELINECHARTFONT,
      fontSize: '10px',
      fontWeight: '500',
    },
    reversed: true,
  },
  plotOptions: {
    line: {
      marker: {
        radius: 2,
      },
      lineWidth: 1,
      states: {
        hover: {
          lineWidth: 1,
        },
      },
      threshold: null,
    },
  },
  credits: {
    enabled: false,
  },
  series: [],
};

export const REPORT_PIE_CHART_COLORS = [
  '#FF0000',
  '#008080',
  '#00FF00',
  '#800080',
  '#FF00FF',
  '#FFFF00',
  '#808000',
  '#00ffff',
  '#ff8080',
  '#ff6600',
  '#4000ff',
  '#ff00ff',
  '#993d00',
  '#72b799',
  '#006600',
  '#cc00ff',
  '#ff9933',
  '#ff66ff',
  '#6666ff',
];
